// Guaubuelo: las secciones aparecen al hacer scroll, en todas las páginas. Sin librerías.
// Lo que ya está a la vista al cargar no se esconde nunca; la primera sección (hero o
// ficha) tampoco. Dentro de cada sección: escalonado, cortina en imágenes y línea bajo el titular.
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const principales = [...document.querySelectorAll('main > .shopify-section')].slice(1);
  const pie = [...document.querySelectorAll('footer .shopify-section')];
  const secciones = [...principales, ...pie].filter((s) => s.getBoundingClientRect().top > window.innerHeight);
  if (!secciones.length) return;

  const ESCALONADO = '.gb-necesidades__item, .gb-promesa__dato, .resource-list__item, .footer-content > *';
  for (const seccion of secciones) {
    // Escalonado por grupo de hermanos
    const vistos = new Map();
    seccion.querySelectorAll(ESCALONADO).forEach((el) => {
      const padre = el.parentElement;
      const i = vistos.get(padre) ?? 0;
      el.style.setProperty('--gb-i', String(Math.min(i, 8)));
      vistos.set(padre, i + 1);
    });
    // Primer titular de la sección: línea que se dibuja (solo h2 de texto, no los de producto)
    const titular = seccion.querySelector('h2:not(.product-card *):not(.jm-review-widget *)');
    if (titular && titular.textContent.trim().length < 80) titular.classList.add('gb-titular-linea');
  }

  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.dataset.gbAparece = 'visto';
        observador.unobserve(entrada.target);
      }
    },
    { rootMargin: '0px 0px -40px 0px' }
  );

  document.documentElement.classList.add('gb-aparecer');
  for (const seccion of secciones) {
    seccion.dataset.gbAparece = 'esperando';
    observador.observe(seccion);
  }
})();
